import { render, staticRenderFns } from "./ContentLoader.vue?vue&type=template&id=13fc7ec2&scoped=true"
import script from "./ContentLoader.vue?vue&type=script&lang=js"
export * from "./ContentLoader.vue?vue&type=script&lang=js"
import style0 from "./ContentLoader.vue?vue&type=style&index=0&id=13fc7ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fc7ec2",
  null
  
)

export default component.exports